import { api } from './api.ts';

export interface InvestmentPlanInput {
  name: string;
  current_age: number;
  withdrawal_start_age: number;
  life_expectancy: number;
  initial_net_worth: number;
  monthly_contribution: number;
  withdrawal_amount?: number;
  expected_nominal_annual_return: number;
  expected_annual_inflation: number;
}

export const investmentPlanApi = {
  createPlan: (payload: InvestmentPlanInput) => api.post('/api/v1/investment-plans', payload),
  listPlans: () => api.get('/api/v1/investment-plans'),
  getPlan: (id: number) => api.get(`/api/v1/investment-plans/${id}`),
  updatePlan: (id: number, payload: InvestmentPlanInput) => api.put(`/api/v1/investment-plans/${id}`, payload),
  generateProjection: (id: number, scenarioId?: number, withdrawalStrategy?: string) =>
    api.post(`/api/v1/investment-plans/${id}/projection`, {
      ...(scenarioId ? { scenario_id: scenarioId } : {}),
      ...(withdrawalStrategy ? { withdrawal_strategy: withdrawalStrategy } : {}),
    }),
  getDepletionAlert: (id: number) => api.get(`/api/v1/investment-plans/${id}/depletion-alert`),
  deletePlan: (id: number) => api.delete(`/api/v1/investment-plans/${id}`),
};
